// extracted by mini-css-extract-plugin
module.exports = {"reveal":"_base-box-5260e07c854910381619bb1ff6eb3141","boxes":"_base-box-072b5cb738d791380acd81459eb5226d"};